import React from 'react';
import ProductCardQuickSearch from '../ProductCards/ProductCardQuickSearch';
import QuickSearchLinkItem from './QuickSearch.LinkItem';
import { SearchItem } from '../../Types/SearchItem';
import { ProductStocks } from '../NavisionStock/types/ProductStocks';

interface QuickSearchResultTabProps extends PriceStateBaseModel {
  modelKey: string;
  results: SearchItem[];
  navisionPrices?: ProductPriceResponseItem[];
  navisionStocks?: ProductStocks[];
}

const QuickSearchResultItem = ({
  modelKey,
  item,
  showBothPrices,
  navisionPrice,
  navisionStock,
}: {
  modelKey: string;
  item: SearchItem;
  showBothPrices: boolean;
  currentPriceToggleType?: string;
  navisionPrice?: ProductPriceResponseItem;
  navisionStock?: ProductStocks;
}) => {
  switch (modelKey) {
    case 'products':
      return (
        <ProductCardQuickSearch
          product={item}
          showBothPrices={showBothPrices}
          navisionPrice={navisionPrice}
          navisionStock={navisionStock}
        />
      );
    default:
      return <QuickSearchLinkItem name={item.name} url={item.url} />;
  }
};

const QuickSearchResultTab = ({
  modelKey,
  results,
  showBothPrices,
  navisionPrices,
  navisionStocks,
  currentPriceToggleType,
}: QuickSearchResultTabProps) => {
  return (
    <div
      id={`quick-search__tab-${modelKey}`}
      className="mt-5 grid h-[calc(100vh_-_100px)] auto-rows-min grid-cols-1 gap-2 overflow-y-auto pb-48 scrollbar-none md:grid-cols-2 lg:h-auto lg:max-h-64 lg:pb-4"
    >
      {results.map((result, index) => (
        <QuickSearchResultItem
          key={index}
          modelKey={modelKey}
          item={result}
          showBothPrices={showBothPrices}
          navisionPrice={navisionPrices?.find(
            (p) => p?.productId == result?.id
          )}
          navisionStock={navisionStocks?.find(
            (p) => p?.productId == result?.id
          )}
          currentPriceToggleType={currentPriceToggleType}
        />
      ))}
    </div>
  );
};

export default QuickSearchResultTab;
